import { createFileRoute, Link, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { AuthShell } from '../components/auth/auth-shell';
import { LoginForm } from '../components/auth/login-form';
import { useAuthStore } from '../stores/auth-store';

function LoginPage() {
  const { t } = useTranslation();
  return (
    <AuthShell
      title={t('auth.login.title')}
      subtitle={t('auth.login.subtitle')}
      footer={
        <div className="flex flex-col items-center gap-2">
          <div>
            {t('auth.login.no_account')}{' '}
            <Link to="/signup" className="font-medium text-primary hover:underline">
              {t('auth.login.signup_link')}
            </Link>
          </div>
          <div className="text-xs text-muted-foreground text-center">
            {t('auth.login.password_help')}
          </div>
        </div>
      }
    >
      <LoginForm />
    </AuthShell>
  );
}

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    if (useAuthStore.getState().status === 'authenticated') {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: LoginPage,
});
